/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


var trustedShopsID = 'XA23BF46A3933CF7A464DCAE42AEB20BC';

// generate random alphanumeric string
function generateRandomString (len) {
  var arr = new Uint8Array((len || 40) / 2)
  window.crypto.getRandomValues(arr);
  return Array.from(arr, function(dec) {
    return ('0' + dec.toString(16)).substr(-2)
  }).join('');
}


// Add Trusted Shops Stars for Products
function addTrustedShopsProductStars() {
  var $tsStarsWrap = $('.product-trustedshops-stars:not(.loaded)');
  if ($tsStarsWrap.length) {
    $tsStarsWrap.each(function() {
      var $this = $(this);
      var sku = $this.attr('data-sku');
      var newID = 'trustedshops-stars-' + generateRandomString(10);
      $this.attr('id', newID);
      $this.addClass('loaded');

      if (typeof sku !== 'undefined' && sku.length > 0) {
        var summaryBadge = new productStickerSummary();
        summaryBadge.showSummary({
          tsid: trustedShopsID,
          element: '#' + newID,
          locale: 'de_DE',
          apiServer: '//cdn1.api.trustedshops.com/',
          sku: sku,
          starSize: '20px',
          enablePlaceholder: 'true',
          showRating: 'true',
          scrollToReviews: 'true',
          fontSize: '14px'
        });
      }

    });
  }
}

function setURLHash(hash) {
  if (hash == '') {
    history.pushState("", document.title, window.location.pathname+ window.location.search);
  } else {
    if(history.pushState) {
      history.pushState(null, null, '#' + hash);
    } else {
      location.hash = '#' + hash;
    }
  }
}

(function($) {
  $(function() {

    function scrollTo($target, speed) {
      $([document.documentElement, document.body]).animate({
        scrollTop: $target.offset().top
      }, speed);
    }

    addTrustedShopsProductStars();

    // Update Trusted Shops rating in footer with live value
    (function() {

      var $tsFooter = $('.trusted-shops-footer');
      if (!$tsFooter.length) return;

      var $ratingCount = $tsFooter.find('[itemprop="ratingCount"]');
      var $ratingValue = $tsFooter.find('[itemprop="ratingValue"]');
      if (!$ratingCount.length || !$ratingValue.length) return;

      var tsURL = 'https://api.trustedshops.com/rest/public/v2/shops/'+trustedShopsID+'/quality/reviews.xml'

      $.ajax({
        type: "GET",
        url: tsURL,
        dataType: "xml",
        success: function(xml) {
         	var oldRatingCount = $ratingCount.text();
          	var oldRatingValue = $ratingValue.text();
            var newRatingCount = newRatingValue = '';

            var $activeReviewCount = $(xml).find('activeReviewCount');
          	if ($activeReviewCount.length && typeof $activeReviewCount[0].innerHTML !== 'undefined') {
				var newRatingCount = $activeReviewCount[0].innerHTML;
            }

			var $overallMark = $(xml).find('overallMark');
          	if ($overallMark.length && typeof $overallMark[0].innerHTML !== 'undefined') {
				var newRatingValue = $overallMark[0].innerHTML;
            }

          	// sanity check
            if (parseInt(newRatingCount) > 1000 && parseFloat(newRatingValue) > 4) {
              $ratingCount.text(newRatingCount);
              $ratingValue.text(newRatingValue);
            }

        }
       });
    })();


    // Grundpreis and delivery times update on variant select
    document.addEventListener("venue:variant:update", function(e) {
      if (typeof e.detail !== "undefined" && typeof e.detail.variant !== "undefined") {
        if (typeof variantsBaseprices[e.detail.variant.id] !== 'undefined') {
          $('.product-single__form .grundpreis').html(variantsBaseprices[e.detail.variant.id]);
        }

        if (typeof variantsDeliveryTimes[e.detail.variant.id] !== 'undefined') {
          setVariantDeliveryTime(e.detail.variant.id);
        }
      }
    });

    function setVariantDeliveryTime(variantID) {
      if (typeof variantsDeliveryTimes[variantID] !== 'undefined') {
        if (variantsDeliveryTimes[variantID] == '') {
          $('.product-single__form .product-deliverytime').hide();
        } else {
          $('.product-single__form .product-deliverytime .custom-field--value').html(variantsDeliveryTimes[variantID]);
          $('.product-single__form .product-deliverytime').show();
        }
      }
    }
    if (typeof currentVariant !== "undefined") {
      setVariantDeliveryTime(currentVariant);
    }
   
    
    // Product Accordion
    
    var scrollToBlock = function(block, offset) {
      var top = block.offset().top;
      $('html, body').animate({
        scrollTop: top-offset
      }, 300);
    };
    
    var blocks = $('.details-block').not('.details-block-link-only');

    blocks.each(function(i,e) {
      
      var block = $(e);
      var content = block.find('.details-block-content');
      var toggle = block.find('h4');
      
      toggle.click(function() {
        if(block.hasClass('open')) {
          block.removeClass('open');
        } else {
          blocks.filter('.open').removeClass('open');
          block.addClass('open');          
          scrollToBlock(block, 200);
        }
      });
    });



  });
})(jQuery);